import MultiStepForm from "@/components/MultiStepForm";
import CandidateFormLayout from "@/layouts/CandidateFormLayout";

const RegistrationForm = () => {
  return (
    <CandidateFormLayout>
      <MultiStepForm />
    </CandidateFormLayout>
  );
};

export default RegistrationForm;
